import { create } from 'zustand';

/**
 * admin 세션 상태 — admin_at 쿠키는 httpOnly 라 JS 가 읽지 못함.
 * 따라서 store 는 /auth/me 응답으로 로그인 여부·user 정보만 보관(토큰 미보관, XSS 안전).
 */
export interface AdminUser {
  id: string;
  email: string;
  name: string;
  role: string;
}

type AuthStatus = 'pending' | 'authenticated' | 'unauthenticated';

interface AdminAuthState {
  status: AuthStatus;
  user: AdminUser | null;
  setAuthenticated: (user: AdminUser) => void;
  clearSession: () => void;
  setPending: () => void;
}

export const useAdminAuthStore = create<AdminAuthState>((set) => ({
  status: 'pending',
  user: null,
  setAuthenticated: (user) => set({ status: 'authenticated', user }),
  clearSession: () => set({ status: 'unauthenticated', user: null }),
  setPending: () => set({ status: 'pending' }),
}));
